import Splide from '@splidejs/splide';
import GLightbox from 'glightbox';

export default class Carousel {
	constructor() {
		this.init();
	}

	init() {
		let carouselElement = document.querySelectorAll( '[data-carousel]' );

		carouselElement.forEach( ( element ) => {
			const carouselType = element.getAttribute('data-carousel');

			let carousel = new Splide( element, {
                type: 'fade',
				autoplay: true,
                interval: 5000,
                rewind: true,
                pauseOnHover: false,
                pauseOnFocus: false,
				pagination: false,
                arrows: true
            } ).mount();

			if ( carouselType === 'lightbox' ) {
				const customLightboxHTML = `<div id="glightbox-body" class="light glightbox-container">
					<div class="gloader visible"></div>
					<div class="goverlay"></div>
					<div class="gcontainer">
					<div id="glightbox-slider" class="gslider"></div>
					<button class="gnext gbtn" tabindex="0" aria-label="Next" data-customattribute="example"><i class="icon-arrow-right"></i></button>
					<button class="gprev gbtn" tabindex="1" aria-label="Previous"><i class="icon-arrow-left"></i></button>
					<button class="gclose gbtn" tabindex="2" aria-label="Close"><i class="icon-plus"></i></button>
				</div>
				</div>`;

				let images = element.querySelectorAll( '[data-lightbox]' );
				let elements = [];

				const lightbox = GLightbox( {
					touchNavigation: true,
					closeOnOutsideClick: true,
					zoomable: false,
					draggable: false,
					openEffect: 'fade',
					closeEffect: 'fade',
					height: 500,
					lightboxHTML: customLightboxHTML
				} );

				images.forEach( ( image, index ) => {
					elements[ index ] = {
						href: image.getAttribute( 'data-lightbox' )
					}

					image.addEventListener( 'click', () => {
						lightbox.openAt( index );
					} );
				} );

				lightbox.setElements( elements );

				lightbox.on('slide_changed', ({ prev, current }) => {
					carousel.go(current.slideIndex);
				});
			}
		} );
	}
}
